import React, {FC} from 'react';

import {Plural, Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {InboxModel} from '../../../../../../../libs/shared/core/src/models/api/inboxModel';
import {MultiButtonsDialog} from '../../../../../../../libs/shared/ui/src/components/dialogs/multiButtonsDialog';

/*
 * Props.
 */

interface MoveAccessdialogContainerProps {
  onKeepAccessClick: () => void;
  onLoseAccessClick: () => void;
  onRequestClose: () => void;
  destinationInbox: InboxModel;
  isUserOnlyFollower: boolean;
  conversationsCount: number;
}

/*
 * Component.
 */

export const MoveAccessDialog: FC<MoveAccessdialogContainerProps> = (props) => {
  const {destinationInbox} = props;

  if (props.isUserOnlyFollower) {
    return (
      <MultiButtonsDialog
        title={<Trans id="moveaccessdialog-title">Move and resolve access</Trans>}
        onRequestClose={props.onRequestClose}
        onPrimaryClick={props.onKeepAccessClick}
        onSecondaryClick={props.onLoseAccessClick}
        primaryButtonLabel={<Trans id="moveaccessdialog-onlyfollower-primary">Retain access</Trans>}
        secondaryButtonLabel={<Trans id="moveaccessdialog-onlyfollower-secondary">Lose access</Trans>}
        disableSameWidth
      >
        <Plural
          id="moveaccessdialog-onlyfollower-body"
          value={props.conversationsCount}
          one={
            <>
              You don&apos;t have access to the <strong>{destinationInbox.name}</strong> shared inbox. Would
              you like to retain access to this conversation after the move?
            </>
          }
          other={
            <>
              You don&apos;t have access to the <strong>{destinationInbox.name}</strong> shared inbox. Would
              you like to retain access to these conversations after the move?
            </>
          }
        />
      </MultiButtonsDialog>
    );
  }

  return (
    <MultiButtonsDialog
      title={<Trans id="moveaccessdialog-title">Move and resolve access</Trans>}
      onRequestClose={props.onRequestClose}
      onPrimaryClick={props.onKeepAccessClick}
      onSecondaryClick={props.onLoseAccessClick}
      primaryButtonLabel={<Trans id="moveaccessdialog-manyfollowers-primary">Maintain access</Trans>}
      secondaryButtonLabel={<Trans id="moveaccessdialog-manyfollowers-secondary">Remove access</Trans>}
      disableSameWidth
    >
      <Plural
        id="moveaccessdialog-manyfollowers-body"
        value={props.conversationsCount}
        one={
          <>
            One or more subscribers don&apos;t have access to the <strong>{destinationInbox.name}</strong>{' '}
            shared inbox. Would you like to maintain access to this conversation for all subscribers after the
            move?
          </>
        }
        other={
          <>
            One or more subscribers don&apos;t have access to the <strong>{destinationInbox.name}</strong>{' '}
            shared inbox. Would you like to maintain access to these conversations for all subscribers after
            the move?
          </>
        }
      />
    </MultiButtonsDialog>
  );
};
